import { nodeDivisions } from '../../../types';

const isFacetOptionsPresentInNavigationData = (facet, webHierarchy, selectedNodes) => {
    const nodeHasChildren = node => {
        if (node.children && node.children.length > 0){
            return true
        }
    };

    const getAllNames = node => {
        let result = [];
        if(nodeHasChildren(node)){
            result = result.concat(node.children.map(getAllNames)).flat()
        }
        return [...result, (node.name || "").trim()]
    };

    const currentDivision = selectedNodes.find(node => node.type === nodeDivisions.division || node.type === nodeDivisions.subDivision).name;

    const styleFacetValues = facet.options.map(option => option.name.trim());

    const getCurrentDivisionNode = node => {
        if (node.children.length === 1 && node.children[0].name === currentDivision){
            return node
        }
    };

    const allWebHierarchyValues =  webHierarchy
    .filter(node => (node.name === currentDivision ? node : getCurrentDivisionNode(node)))
    .map(getAllNames)
    .flat()
    .filter(name => name !== undefined);

    const styleFacetValuesThatAreAlsoCategories = styleFacetValues.filter(facet => allWebHierarchyValues.indexOf(facet) > 0);

    return !(styleFacetValuesThatAreAlsoCategories.length >= Math.floor(styleFacetValues.length / 3));
};

export default isFacetOptionsPresentInNavigationData;